import MetaImage from '../../img/meta.jpg';
import COWImage from '../../img/cow.jpg';
import HSImage from '../../img/highschool.jpg';
import LAHacksImage from '../../img/lahacks.jpeg';
import PushcarImage from '../../img/pushcar.jpg';
import ChantImage from '../../img/chanterelle.jpg';
import PanthImage from '../../img/pantherina.jpg';
export const ImageData = [
    {
        image: MetaImage,
        alt: 'Meta 2022',
        text: 'Summer 2022 at Meta Seattle!'

    },
    {
        image: COWImage,
        alt: 'COW 2022',
        text: 'Amazing Chicken of the Woods polypore :)'
    },
    {
        image: HSImage,
        alt: 'Highschool 2020',
        text: 'Candid shot of me coding MHS-Protect when I had green hair.'
    },
    {
        image: LAHacksImage,
        alt: 'LAHacks 2022',
        text: 'Candid shot of me coding Friend-In-Need'
    },
    {
        image: ChantImage,
        alt: 'Chanterelle 2022',
        text: 'Beautiful chanterelle!'
    },
    {
        image: PushcarImage,
        alt: 'Pushcar 2022',
        text: 'My beautiful, albeit stupid cat <3'
    },
    {
        image: PanthImage,
        alt: 'Amanita Pantherina 2022',
        text: 'Amanita Pantherina found at Poo Poo Point'
    },
];